import { isBefore } from 'date-fns'
import clamp from 'lodash-es/clamp'

import { HOUR_FIRST_MINUTE, HOUR_LAST_MINUTE } from '../../../../constants/date'
import { CALENDAR_GRID_MINUTES_PER_ROW } from '../../CalendarGrid.constants'

export function getIsCalendarGridWeekCellPast({ now, start }) {
  return isBefore(start, new Date(now))
}

export function getIsCalendarGridWeekCellDisabled({ isPast, onClick }) {
  return !onClick || isPast
}

// The minute of the day under the pointer, so a drag follows it inside an hour row
export function getCalendarGridWeekCellPointerMinutes({ event, hour }) {
  const { height, top } = event.currentTarget.getBoundingClientRect()

  const rowMinutes = Math.floor(
    ((event.clientY - top) / height) * CALENDAR_GRID_MINUTES_PER_ROW
  )

  return (
    hour * CALENDAR_GRID_MINUTES_PER_ROW +
    clamp(rowMinutes, HOUR_FIRST_MINUTE, HOUR_LAST_MINUTE)
  )
}
